import glsHtml from './gls.component.html';
import './gls.component.scss';

class GlsController {
    constructor($scope, $timeout, GlsService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = GlsService;

        this.localLoading = true;
        this.postCodeDebounce = null;
        this.showAdditionalServices = false;

        this.note = '';
        this.postCode = '';
        this.options = [];
        this.selectedOption = '';
    }

    get customOptions() {
        const options = {};

        options.note = this.note;
        options.additionalService = this.selectedOption;

        return options;
    }

    $onInit() {
        this.service.getStatus().then(
            (data) => {
                if (data.note)
                    this.note = data.note;
                
                if (data.services && data.services.length > 0 && data.zip && data.zip != '') {
                    this.postCode = data.zip;
                    this.showAdditionalServices = true;
                    
                    this.service.getAvailableOptions(this.postCode).then(
                        (options) => {
                            this.localLoading = false;
                            this.prepareOptions(options);
                            this.selectedOption = data.services[0];
                            this.watchForSave();
                        },
                        () => {
                            this.localLoading = false;
                            this.watchForSave();
                        }
                    );
                    
                } else {
                    this.localLoading = false;
                    this.watchForSave();
                }
            },
            () => {
                this.watchForSave();
            }
        );
    }

    watchForSave() {
        this.$scope.$watch(
            () => this.note,
            (newVal, oldVal) => {
                if (newVal == oldVal) return;

                this.setNote();
            }
        );

        this.$scope.$watch(
            () => this.postCode,
            (newVal, oldVal) => {
                if (this.postCodeDebounce) {
                    this.$timeout.cancel(this.postCodeDebounce);
                    this.postCodeDebounce = null;
                }

                if (newVal == oldVal) return;

                if (!this.postCode || this.postCode == '' || this.postCode.length != 6) return;

                this.postCodeDebounce = this.$timeout(
                    () => {
                        this.getAvailableOptions();
                    },
                    500
                );

            }
        );
    }

    setNote() {
        this.localLoading = true;

        this.service.setNote(this.note).then(
            () => {
                this.localLoading = false;
            },
            () => {
                this.localLoading = false;
            }
        );
    }

    getAvailableOptions() {
        this.options = [];
        this.selectedOption = '';

        if (this.postCode == '') return;
        
        this.localLoading = true;

        this.service.getAvailableOptions(this.postCode).then(
            (options) => {
                this.localLoading = false;

                this.prepareOptions(options);
            },
            () => {
                this.localLoading = false;
            }
        );
    }

    prepareOptions(options) {
        this.options = [];

        for (const property in options.servicesDesc) {
            if (options[property] && options[property] == 'Y') {
                this.options.push({
                    name: options.servicesDesc[property].desc,
                    value: property,
                    price: options.servicesDesc[property].price
                });
            }
        }
    }

    setOption(option) {
        if (option.value == this.selectedOption) return;

        this.localLoading = true;
        this.selectedOption = option.value;

        this.service.setOption(option.value, this.postCode, option.name).then(
            () => {
                this.saveCustomOptions();
                this.localLoading = false;
            },
            () => {
                this.localLoading = false;
            }
        );
    }

    saveCustomOptions() {
        this.save({
            shipment: this.shipment,
            options: this.customOptions
        });
    }

    clear() {
        this.note = '';
        this.postCode = '';
        this.options = [];
        this.selectedOption = '';
    }
}

let glsComponent = {
    bindings: {
        loading: '<',
        shipment: '<',
        payment: '<',
        selected: '<',
        save: '&'
    },
    template: glsHtml,
    controller: GlsController
}

export default glsComponent;